<div [class]="'e-btn-group' + cssClass"
     [formGroup]="form">
  <ng-container *ngFor="let item of keyList">
    <input type="checkbox"
           [id]="id + '-' + fieldsEnum[item.value]"
           [formControlName]="fieldsEnum[item.value]"
           [value]="item.value"/>
    <label class="e-btn d-flex align-items-center"
           [ngClass]="{
              'fixed-width': fixedWidth,
              'inline': inline,
              'disabled': form.get(fieldsEnum[item.value]).disabled
           }"
           [for]="id + '-' + fieldsEnum[item.value]">{{ item.text | translate }}</label>
  </ng-container>
</div>
